// Feb 2026 owner-approved Visitor Prize Draw NOTICE.
//
// This is INFORMATIONAL only — it is NOT a consent surface, does NOT
// carry a mandatory checkbox, and is completely independent of the
// existing (dormant, gated-off) `VISITOR_PRIZE_DRAW_ENABLED` consent
// plumbing. Displaying this card does NOT activate a draw, create
// winners, write to the database, or issue tickets.
//
// PUBLIC WEB (Feb 2026 correction): the notice renders ONLY the copy
// in the active language — English mode shows the EN block, Arabic
// mode shows the AR block. This matches the rest of the portal, which
// follows the language toggle. The email builder (server.py) renders
// both languages together (AR first, then EN) — that is a separate,
// server-side layout and is unaffected by this component.
import React from "react";
import { Award } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export const VisitorPrizeNotice = ({ className = "" }) => {
  const { t, isRTL } = useLanguage();

  const headingClass = isRTL
    ? "text-[#F5C518] font-extrabold text-xl sm:text-2xl mb-2 leading-tight text-center"
    : "text-[#F5C518] font-extrabold text-xl sm:text-2xl tracking-wide mb-2 leading-tight text-center";

  const bodyClass = isRTL
    ? "text-white text-base sm:text-lg md:text-xl leading-relaxed font-medium text-center"
    : "text-white/95 text-base sm:text-lg leading-relaxed text-center";

  const arStyle = isRTL
    ? { fontFamily: "'Noto Sans Arabic', 'Tajawal', system-ui, sans-serif", letterSpacing: "normal" }
    : undefined;

  return (
    <div
      className={
        "border border-[#F5C518]/50 bg-[#F5C518]/[0.06] backdrop-blur-sm " +
        "px-5 py-5 sm:px-6 sm:py-6 " + className
      }
      role="note"
      aria-label={isRTL ? "إشعار سحب على جوائز للزوار" : "Visitor Prize Draw notice"}
      data-testid="visitor-prize-notice"
      lang={isRTL ? "ar" : "en"}
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="flex flex-col items-center gap-3 text-center">
        <Award className="w-6 h-6 text-[#F5C518] shrink-0" aria-hidden="true" />
        <div className="w-full">
          <div
            className={headingClass}
            style={arStyle}
            data-testid={isRTL ? "visitor-prize-notice-ar-heading" : "visitor-prize-notice-en-heading"}
          >
            {isRTL ? t("visitorPrizeNoticeHeadingAR") : t("visitorPrizeNoticeHeadingEN")}
          </div>
          <p
            className={bodyClass}
            style={arStyle}
            data-testid={isRTL ? "visitor-prize-notice-ar-body" : "visitor-prize-notice-en-body"}
          >
            {isRTL ? t("visitorPrizeNoticeBodyAR") : t("visitorPrizeNoticeBodyEN")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VisitorPrizeNotice;
